import { type FC } from "react"
import { Link, useLocation } from "react-router"

import useCookieOption, { cookieOptions } from "~/hooks/useCookieOption"
import useMatomo from "~/hooks/useMatomo"
import Button from "~/themes/original/components/Button"
import Modal, { ModalButtons, ModalText, ModalTitle } from "~/themes/original/components/Modal"
import routes from "~/utilities/routes"

const CookieConsent: FC = () => {
	const location = useLocation()

	const [cookieOption, setCookieOption] = useCookieOption()

	useMatomo({ hasCookieConsent: cookieOption !== null && Boolean(cookieOption & cookieOptions.analytics) })

	return (
		<Modal isOpen={cookieOption === null && location.pathname !== routes.policy.cookie()}>
			<ModalTitle>We value your privacy</ModalTitle>
			<ModalText>
				We use cookies to authenticate you and collect privacy-friendly statistics. No cookies are loaded until
				you make a choice. You can read more about our use of cookies in our{" "}
				<Link to={routes.policy.cookie()}>cookie policy</Link>.
			</ModalText>
			<ModalButtons>
				<Button variant="secondary" onClick={() => setCookieOption(cookieOptions.functional)}>
					Use only functional
				</Button>
				<Button
					variant="primary"
					onClick={() => setCookieOption(cookieOptions.functional | cookieOptions.analytics)}
				>
					Accept
				</Button>
			</ModalButtons>
		</Modal>
	)
}

export default CookieConsent
